export enum MathEnum {
    Addition = 0,
    Substraction = 1
}

